<div class="program-wrap" *ngIf="programDelegate">
    <!-- ********************   LEARNER START   *********************************  -->
    <ng-container *ngIf="level == 'learner'">
        <div class="title my-color-blue content-wrap" [@enter]>
            {{'__JOURNEY_STAGE__' | translate}} {{stage.current}}: <span>{{stage.details.title}}</span> <br>
            <strong>{{programDelegate.program.title}}</strong>
        </div>
        <div class="blue-bg" *ngIf="programDelegate" [@enter]>
            <div class="content-wrap-inner">
                <div class="line">
                    <div class="my-color-blue">{{'__JOURNEY_DATE__' | translate}}</div>
                    <div class="text">{{programDelegate.program.program_dates}}</div>
                </div>
                <div class="line">
                    <div class="my-color-blue">{{'__JOURNEY_TIME__' | translate}}</div>
                    <div class="text">{{programDelegate.program.time}}</div>
                </div>
                <div class="line line-break">
                    <div class="my-color-blue">{{'__JOURNEY_VENUE__' | translate}}</div>
                    <div class="list-line">
                        <span *ngIf="programDelegate.program.venue.name">{{programDelegate.program.venue.name}}</span>
                        <span *ngIf="programDelegate.program.venue.contact_name">{{programDelegate.program.venue.contact_name}}</span>
                        <span *ngIf="programDelegate.program.venue.email">{{programDelegate.program.venue.email}}</span>
                        <span *ngIf="programDelegate.program.venue.addr1">{{programDelegate.program.venue.addr1}}</span>
                        <span *ngIf="programDelegate.program.venue.addr2">{{programDelegate.program.venue.addr2}}</span>
                        <span *ngIf="programDelegate.program.venue.addr3">{{programDelegate.program.venue.addr3}}</span>
                        <span *ngIf="programDelegate.program.venue.addr4">{{programDelegate.program.venue.addr4}}</span>
                        <span *ngIf="programDelegate.program.venue.post">{{programDelegate.program.venue.post}}</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <!-- ********************   LEARNER END   *********************************  -->


    <!-- ********************   MANAGER START   *********************************  -->

    <ng-container *ngIf="level == 'manager'">
        <div class="title my-color-blue content-wrap">
            {{'__JOURNEY_NAME__' | translate}} <span>{{programDelegate.delegate.full_name}}</span>
        </div>
    </ng-container>

    <!-- ********************   MANAGER END   *********************************  -->


    <!-- ***************   COMMON PART CONTINUE  ******************************  -->
    <div class="content-wrap">
        <div class="check-line" [@enter]>
            <div>
                <img src="assets/img/people.svg" alt="people">
                <div class="text strong">{{'__JOURNEY_ATTENDANCE__' | translate}}</div>
            </div>
            <div>
                <div class="text">{{'__JOURNEY_CONFIRM__' | translate}}</div>
                <ion-checkbox class="My-checkbox" [(ngModel)]="programDelegate.attend_need"
                              (click)="changeAttendance(!programDelegate.attend_need)"
                              [disabled]="level == 'manager'"></ion-checkbox>
            </div>
        </div>

        <hr>

        <div class="list" [@enter]>
            <strong class="my-color-blue">{{'__JOURNEY_OVERVIEW__' | translate}}</strong>
            <div class="text-formatted" [innerHTML]="programDelegate.program.intro"></div>
        </div>

        <hr>

        <div class="text">
            <div class="title my-color-blue">{{'__JOURNEY_OBJECTIVES__' | translate}}</div>
            <strong>{{'__JOURNEY_OBJECTIVES_DESC__' | translate}}</strong>
        </div>


        <textarea *ngIf="level == 'learner' " (input)="onChange($event)" aria-label="" class="swiper-no-swiping"
                  [(ngModel)]="programDelegate.del_obj.value"></textarea>
        <div *ngIf="level == 'manager'" class="text-grey" [innerHTML]="programDelegate.del_obj.output"></div>

        <div class="text">
            <div class="title my-color-blue smaller">{{'__JOURNEY_MANAGER__' | translate}}</div>
            <strong>{{'__JOURNEY_MANAGER_DESC__' | translate}}</strong>
        </div>

        <textarea *ngIf="level == 'manager' " (input)="onChange($event)" aria-label="" class="swiper-no-swiping"
                  [(ngModel)]="programDelegate.man_obj.value"></textarea>
        <div *ngIf="level == 'learner'" class="text-grey" [innerHTML]="programDelegate.man_obj.output"></div>

        <hr>

        <div class="text">
            <div class="title my-color-blue">{{'__JOURNEY_TRAINER__' | translate}}</div>
            <strong>{{'__JOURNEY_TRAINER_DESC__' | translate}}</strong>
        </div>

        <div class="text-grey" [innerHTML]="programDelegate.trainer_comments.output"></div>

        <div class="text" *ngIf="level == 'learner'">
            <div class="title my-color-blue">{{'__JOURNEY_FEEDBACK__' | translate}}</div>
            <div class="text-legend">
                <span><strong>1</strong> - {{'__JOURNEY_FEEDBACK_LEGEND1__' | translate}}</span>
                <span><strong>2</strong> - {{'__JOURNEY_FEEDBACK_LEGEND2__' | translate}}</span>
                <span><strong>3</strong> - {{'__JOURNEY_FEEDBACK_LEGEND3__' | translate}}</span>
                <span><strong>4</strong> - {{'__JOURNEY_FEEDBACK_LEGEND4__' | translate}}</span>
                <span><strong>5</strong> - {{'__JOURNEY_FEEDBACK_LEGEND5__' | translate}}</span>
            </div>
        </div>

        <div class="feedback-list" *ngIf="level == 'learner'">
            <div class="item" *ngFor="let question of programDelegate.feedback.training; let i = index;">
                <div class="number my-color-blue">{{i + 1}}.</div>
                <div class="content">
                    <div class="text">
                        {{question.title}}
                    </div>
                    <app-radio-group (valueChange)="onChange($event)" [items]="radioGroup" [value]="question.value.toString()"
                                     class="swiper-no-swiping"></app-radio-group>
                </div>
            </div>
            <div class="item" *ngFor="let question of programDelegate.feedback.company; let i = index;">
                <div class="number my-color-blue">{{i + 1 + programDelegate.feedback.training.length}}.</div>
                <div class="content">
                    <div class="text">
                        {{question.title}}
                    </div>
                    <app-radio-group (valueChange)="onChange($event)" [items]="radioGroup"
                                     [value]="question.value.toString()"></app-radio-group>
                </div>
            </div>
        </div>

        <div class="feedback-comment" *ngIf="level == 'learner'">
            <div class="text">
                <div class="title my-color-blue">{{'__JOURNEY_FEEDBACK_COMMENTS__' | translate}}</div>
            </div>

            <div class="text"><strong>{{'__JOURNEY_FEEDBACK_COMMENT_DESC1__' | translate}}</strong></div>
            <textarea (input)="onChange($event)" aria-label="" class="swiper-no-swiping"
                      [(ngModel)]="programDelegate.feedback.comment1.value"></textarea>

            <div class="text"><strong>{{'__JOURNEY_FEEDBACK_COMMENT_DESC2__' | translate}}</strong></div>
            <textarea (input)="onChange($event)" aria-label="" class="swiper-no-swiping"
                      [(ngModel)]="programDelegate.feedback.comment2.value"></textarea>

            <div class="text"><strong>{{'__JOURNEY_FEEDBACK_COMMENT_DESC3__' | translate}}</strong></div>
            <textarea (input)="onChange($event)" aria-label="" class="swiper-no-swiping"
                      [(ngModel)]="programDelegate.feedback.comment3.value"></textarea>
        </div>

        <hr>

        <div class="text">
            <div class="title my-color-blue">{{'__JOURNEY_REVIEW__' | translate}}</div>
            <strong>{{'__JOURNEY_REVIEW_DESC__' | translate}}</strong>
        </div>

        <div class="text-grey-light-title my-color-blue smaller">{{'__JOURNEY_REVIEW_TITLE1__' | translate}}</div>
        <textarea *ngIf="level == 'learner'" (input)="onChange($event)" aria-label="" class="swiper-no-swiping"
                  [(ngModel)]="programDelegate.del_act_outcomes.value"></textarea>
        <div *ngIf="level == 'manager'" class="text-grey" [innerHTML]="programDelegate.del_act_outcomes.output"></div>

        <div class="text-grey-light-title my-color-blue smaller">{{'__JOURNEY_REVIEW_TITLE2__' | translate}}</div>
        <textarea *ngIf="level == 'manager'" (input)="onChange($event)" aria-label="" class="swiper-no-swiping"
                  [(ngModel)]="programDelegate.man_act_outcomes.value"></textarea>
        <div *ngIf="level == 'learner'" class="text-grey" [innerHTML]="programDelegate.man_act_outcomes.output"></div>

        <div class="btn-group" *ngIf="!!programDelegate.accreditations && programDelegate.accreditations.length > 0">
            <div class="my-color-blue">{{programDelegate.accreditations[0].title}}</div>
            <div class="btn touch-eff" [ngClass]="programDelegate.accreditations[0].pass.style.class">
                {{programDelegate.accreditations[0].comments}}
            </div>
            <strong class="my-color-blue">{{'__JOURNEY_ASSESSMENT_DATE__' | translate}}
                <span>{{programDelegate.accreditations[0].date}}</span>
            </strong>
        </div>

        <div class="img-group" *ngIf="!!programDelegate.scan_file">
            <img *ngIf="false" src="assets/img/disket.svg" alt="#" class="touch-eff-radius" (click)="onSubmit()">
            <div (click)="openFile(programDelegate.scan_file)">
                <img src="assets/img/download.svg" alt="#" class="touch-eff">
                <span>{{'__JOURNEY_DOWNLOAD_BUTTON__' | translate}}</span>
            </div>
        </div>
    </div>
</div>
